<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="d-flex">
			<div style="width: 100%;margin-top: 10px;">
				<div class="d-flex" style="align-items: center;">
					<div style="font-size: 16px;font-weight: 800;margin-right: 10px;">班车司机表单</div>
					<el-select v-model="ck_id" filterable style="width: 100px;" size="mini" @change="curr">
					    <el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<div style="margin-left: 10px;align-items: center;" class="d-flex">
						<div style="margin-left: 10px;font-size: 12px;" :class="sjzt_sb == 1 ? 'xzzta': 'xzztb'" @click="sbztqh(1)">上班中</div>
						<div style="margin-left: 10px;font-size: 12px;" :class="sjzt_sb == 0 ? 'xzzta': 'xzztb'" @click="sbztqh(0)">休息中</div>
					</div>
				</div>
				<el-table :data="sjlist" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight">
					<el-table-column align="center" prop="name" width="90" label="名称" fixed="left"></el-table-column>
					<el-table-column align="center" width="100" label="工作状态">
						<template slot-scope="scope">
							<el-button type="info" size="mini" plain v-if="scope.row.gzzt == 0">休息</el-button>
							<el-button type="warning" size="mini" plain v-if="scope.row.gzzt == 1">上货</el-button>
							<el-button type="primary" size="mini" plain v-if="scope.row.gzzt == 2">发货</el-button>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="phone" width="120" label="手机"></el-table-column>

					<el-table-column align="center" prop="bc_cd" width="90" label="长度"></el-table-column>
					<el-table-column align="center" prop="bc_kd" width="90" label="宽度"></el-table-column>
					<el-table-column align="center" prop="bc_gd" width="90" label="高度"></el-table-column>
					<el-table-column align="center" prop="bc_zdtj" width="90" label="最大体积"></el-table-column>
					<el-table-column align="center" prop="bc_zdzl" width="90" label="最大重量"></el-table-column>
					<el-table-column align="center" prop="bc_cp" label="车牌"></el-table-column>
					<el-table-column align="center" prop="bc_bz" label="备注"></el-table-column>
					<!-- 操作 -->
					<el-table-column align="center" label="操作" fixed="right" width="80">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" @click="openModel(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog title="司机设置" :visible.sync="createModel" top="10vh">
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form ref="form" :model="dqsj" label-width="80px">
					<div class="d-flex">
						<div style="width: 50%;">
							<el-form-item label="名称">
								<div>{{dqsj.name}}</div>
							</el-form-item>
						</div>
						<div style="width: 50%;">
							<el-form-item label="手机">
								<div>{{dqsj.phone}}</div>
							</el-form-item>
						</div>
					</div>
					<div class="d-flex">
						<div style="width: 33%;">
							<el-form-item label="班车长度">
								<el-input-number size="mini" v-model="dqsj.bc_cd" style="width: 90%;" :min='0' :precision="2" @change="handjstj"></el-input-number>
							</el-form-item>
						</div>
						<div style="width: 33%;">
							<el-form-item label="班车宽度">
								<el-input-number size="mini" v-model="dqsj.bc_kd" style="width: 90%;" :min='0' :precision="2" @change="handjstj"></el-input-number>
							</el-form-item>
						</div>
						<div style="width: 33%;">
							<el-form-item label="班车高度">
								<el-input-number size="mini" v-model="dqsj.bc_gd" style="width: 90%;" :min='0' :precision="2" @change="handjstj"></el-input-number>
							</el-form-item>
						</div>
					</div>
					<div class="d-flex">
						<div style="width: 33%;">
							<el-form-item label="班车重量">
								<el-input-number size="mini" v-model="dqsj.bc_zdzl" style="width: 70%;" :min='0' :precision="2"></el-input-number><span style="margin-left: 10px;">吨</span>
							</el-form-item>
						</div>
						<div style="width: 33%;">
							<el-form-item label="班车体积">
								<div>{{dqsj.bc_zdtj}}<span style="margin-left: 10px;">m³</span></div>
							</el-form-item>
						</div>
						<div style="width: 33%;">
							<el-form-item label="所属仓库">
								<el-select v-model="dqsj.bc_ssck" placeholder="请选择" size="mini" style="width: 100px;">
									<el-option v-for="item in cklist" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="班车车牌">
						<el-input v-model="dqsj.bc_cp" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="班车备注">
						<el-input v-model="dqsj.bc_bz" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="qrsz">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			maxHeight: 0,
			sjlist:[],
			ck_id:0,
			dqck:1,
			cklist:[],
			sjzt_sb:1,
			dqsj:{},
			createModel: false,
		};
	},
	filters: {

	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 196;
		});
		
		this.getsjlist();
		
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
			this.cklist.unshift({
				id: 0,
				name: '全部'
			})
		});
		
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
		this.axios.get('/admin/lhlx/1', { token: true }).then(res => {
			this.lhlxlist = res.data.data.list;
		});
		this.axios.get('/admin/zxglist', { token: true }).then(res => {
			this.zxglist = res.data.data;
		});
		this.axios.get('/admin/lhylist', { token: true }).then(res => {
			this.lhylist = res.data.data;
		});
		
	},
	methods: {
		curr(val){
			this.ck_id = val
			this.getsjlist()
		},
		sbztqh(e){
			if(this.sjzt_sb != e){
				this.sjzt_sb = e
				this.getsjlist()
			}
		},
		getsjlist() {
			let data = {
				dqck: this.dqck,
				sbzt: this.sjzt_sb,
				ck_id: this.ck_id
			}
			this.axios.post('/admin/bcsj/list',data,{
				token: true
			}).then(res => {
				this.sjlist = res.data.data
			})
		},
		openModel(e) {
			this.dqsj = e
			this.createModel = true;
		},
		qrsz(){
			this.axios.post('/admin/bcsj_sz',this.dqsj,{
				token: true
			}).then(res => {
				this.sjlist = res.data.data
				this.getsjlist()
				this.dqsj = {}
				this.createModel = false;
			})
			
		},
		handjstj(){
			this.dqsj.bc_zdtj = (this.dqsj.bc_cd * this.dqsj.bc_kd * this.dqsj.bc_gd).toFixed(2)
		}
	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.xzzta{
	color:#0057fa;
	border: 1px solid #0057fa;
	padding: 3px;
	border-radius: 4px;
}
.xzztb{
	color:#9e9e9e;
	border: 1px solid #9e9e9e;
	padding: 3px;
	border-radius: 4px;
}
</style>
